var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScaleBothDown = function SvgScaleBothDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 39,
    viewBox: "0 0 5.7 5.57",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33 2c.19-.01.36.15.37.34 0 .2-.15.37-.35.37L5 2.73c-.47.02-.89.04-1.43-.04-.05-.01-.1-.01-.13-.01-.51.02-.61.02-.59-1.07 0-.18 0-.34-.01-.49 0-.26-.01-.49.01-.78.01-.2.18-.35.38-.34.2.01.35.18.34.38-.02.28-.02.49-.01.72v.52c0 .35-.01.35.11.35.06 0-.1 0 0 .01.48.07.87.05 1.3.03L5.33 2zM2.8 5.29c-.05.19-.24.31-.44.27a.355.355 0 0 1-.26-.43l-.01-.31c-.01-.35-.03-.84.01-1.28-.11.01-.23.02-.37 0-.2-.02-.61-.02-.96-.03H.35A.365.365 0 0 1 0 3.14c0-.19.17-.35.37-.35l.41.01c.37 0 .81.01 1.03.03.12.01.26-.01.36-.02.12-.02.22-.03.33-.01.29.05.42.21.35.57-.08.43-.06 1.03-.05 1.42.01.24.02.41 0 .5z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgScaleBothDown;